export default {
  title: 'Invite to the organization',
  role: 'Role',
  roleHint: 'What the invited people will hold once they accept.',
  rolesUnavailable: 'The roles could not be loaded.',
  send: 'Send ({count})',
  sent: 'Invitations sent: {count}.',
  alreadyMembers: 'Already members of the organization:',
  failed: 'These invitations could not be sent:',
  roleTooHigh: 'Your role cannot grant this one. Pick a role that holds no more than yours.',
  rateLimited: 'Too many invitations for now. Try again later.',
  mailUnavailable: 'Email cannot be sent from this platform right now. Try again later.',
  accessTooHigh:
    'Your role cannot grant this role, or access to one of these workspaces. Pick a role that holds no more than yours.',
  access: {
    customizeTitle: 'Give access to workspaces',
    searchPlaceholder: 'Search a workspace…',
    defaultRole: 'Default role',
    noResults: 'No workspace matches',
    private: 'Private workspace',
    public: 'Public workspace',
    unavailable: 'The workspaces could not be loaded.',
    workspaceGone: 'One of the chosen workspaces no longer exists. Reload the list and try again.',
  },
  preview: {
    title: 'What they will have access to',
    allWorkspaces: 'All workspaces',
    readOnly: 'Read-only',
    grantedTitle: 'Workspaces you grant',
    publicTitle: 'Public workspaces, reached automatically',
    publicNote: 'Read-only, without being added to them.',
    noWorkspaces: 'Organization member only — no access to any workspace.',
  },
  viewInvitations: 'Pending invitations',
}
